module.exports = __webpack_public_path__ + "static/media/quotation-mark-white.13e63e97.svg";